const UNICODE_LETTER_OR_NUMBER = /^[\p{L}\p{N}]$/u;

export const isSearchWordCharacterAt = (text: string, index: number): boolean => {
  if (index < 0 || index >= text.length) {
    return false;
  }

  const getCharacter = (characterIndex: number) => {
    if (characterIndex < 0 || characterIndex >= text.length) {
      return '';
    }

    const codeUnit = text.charCodeAt(characterIndex);
    const codePointIndex =
      codeUnit >= 0xdc00 && codeUnit <= 0xdfff && characterIndex > 0 ? characterIndex - 1 : characterIndex;
    const codePoint = text.codePointAt(codePointIndex);

    return codePoint === undefined ? '' : String.fromCodePoint(codePoint);
  };

  const character = getCharacter(index);

  if (UNICODE_LETTER_OR_NUMBER.test(character)) {
    return true;
  }

  if (character !== "'" && character !== '’') {
    return false;
  }

  return (
    UNICODE_LETTER_OR_NUMBER.test(getCharacter(index - 1)) && UNICODE_LETTER_OR_NUMBER.test(getCharacter(index + 1))
  );
};
